<template>
    <div style="overflow: auto">
        <div class="mb-4">
            <input type="text" v-model="search" class="form-control form-control-lg shadow-sm" placeholder="Cerca assistito o Codice..." />
        </div>
        <div v-for="pratica in praticheFiltrate" :key="pratica.pr_id" class="card sa-siat-card-pratica shadow-sm">
            <div class="sa-siat-card-header-custom">
                <b-row>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Pratica</div>
                        <small style="font-size: 1rem; color: #07077d; font-weight: bold">#{{ pratica.pr_id }}</small>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Stato</div>
                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + pratica.stato.toLowerCase()">{{ pratica.stato }}</span>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Bisogno</div>
                        <span class="sa-siat-data" :class="'sa-siat-data-' + bisogno(pratica)">{{ pratica.bisogno }}</span>
                    </b-col>
                </b-row>
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="sa-siat-label-pai">Assistito</div>
                        <div class="h5 mb-0 text-primary">{{ pratica.assistito.cognome }} {{ pratica.assistito.nome }}</div>
                        <small class="text-muted sa-siat-text-indirizzo"><i class="fas fa-map-marker-alt"></i> {{ pratica.assistito.indirizzoDiResidenza }}</small>
                    </div>
                    <div class="col-md-4">
                        <div class="sa-siat-label-pai">Codice Fiscale</div>
                        <span class="sa-siat-data">{{ pratica.assistito.codiceFiscale }}</span>
                    </div>
                    <div class="col-md-4">
                        <div class="sa-siat-label-pai">Distretto / Stato</div>
                        <div>{{ pratica.distretto.code }} - {{ pratica.distretto.descrizione }}</div>
                    </div>
                </div>
            </div>

            <div class="pb-3 pt-2 bg-light">
                <div class="px-4 mb-2 small font-weight-bold text-muted text-uppercase">Elenco Prestazioni Attive:</div>

                <div class="px-4 mb-2" v-for="pac in pratica.pacchettoAssistenziale" :key="pac.ia_id">
                    <b-row class="mx-2 my-3">
                        <b-col cols="6">
                            <div style="text-align: right">
                                <div class="sa-siat-label-pai">Codice Pacchetto</div>
                                <span class="badge badge-pill badge-light border sa-siat-badge sa-siat-badge-aperta" style="display: inline-block">
                                    <small style="font-size: 1rem; color: #07077d; font-weight: bold">#{{ pac.pacchettoCodice }}</small></span
                                >
                            </div>
                        </b-col>
                        <b-col cols="6">
                            <div style="text-align: left">
                                <div class="sa-siat-label-pai">Costo Accesso</div>
                                <span class="badge badge-pill badge-light border sa-siat-badge sa-siat-badge-aperta" style="display: inline-block">
                                    {{ getFormatoEuro(pac.costoAccesso) }}
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                    <div v-for="ev in pac.evento" :key="ev.id">
                        <b-row class="sa-siat-row">
                            <b-col class="sa-siat-cols" cols="12" md="3">
                                <div class="sa-siat-label-pai">Id Evento</div>
                                <div class="sa-siat-valore-pai">{{ ev.id }}</div>
                            </b-col>

                            <b-col class="sa-siat-cols" cols="12" md="6">
                                <b-alert v-if="ev.presaInCarico" variant="success" show class="mb-0 py-1 shadow-sm"> <i class="fas fa-check-circle mr-1"></i> Presa in carico OK </b-alert>
                                <b-alert v-if="ev.errorePresa" variant="danger" show class="mb-0 py-1 shadow-sm"> <i class="fas fa-exclamation-circle mr-1"></i> {{ ev.errorePresa }} </b-alert>
                            </b-col>
                            <b-col class="sa-siat-cols" cols="12" md="3">
                                <div style="display: inline-block; text-align: right; width: 100%">
                                    <template v-if="ev.statoRecord == 'LETTURA CONFERMATA'">
                                        <span :class="getClassRecordEvento(ev)">{{ ev.statoRecord }}</span>
                                    </template>
                                    <template v-else>
                                        <button class="btn btn-primary btn-presa shadow-sm" @click.stop="onConfermaLetturaScelta(ev)"><i class="fas fa-hand-holding-medical mr-1"></i> Conferma Lettura</button>
                                    </template>
                                </div>
                                <!-- <button v-else class="btn btn-success btn-presa" disabled><i class="fas fa-check mr-1"></i> In Carico</button> -->
                            </b-col>
                        </b-row>
                        <div v-for="pres in ev.prestazione" :key="pres.pi_id" class="sa-siat-prestazione-item shadow-xs" :class="'sa-siat-border-' + pres.figuraProfessionale.ra_cod">
                            <div class="sa-siat-prestazione-header" @click="togglePrestazione(pres.pi_id)">
                                <div>
                                    <span class="badge badge-outline-secondary mr-2">{{ pres.figuraProfessionale.ra_cod }}</span>
                                    <strong>{{ pres.tipoPrestazione }}</strong>
                                </div>
                                <i class="fas text-muted" :class="isPresOpen(pres.pi_id) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </div>

                            <div v-if="isPresOpen(pres.pi_id)" class="prestazione-detail">
                                <b-row class="sa-siat-row">
                                    <b-col class="sa-siat-cols" cols="12" md="3">
                                        <div class="sa-siat-label-pai">Codice PAI</div>
                                        <div class="sa-siat-valore-pai">{{ pres.po_id }}</div>
                                    </b-col>
                                    <b-col class="sa-siat-cols" cols="12" md="3">
                                        <div class="sa-siat-label-pai">Data Inizio Intervento</div>
                                        <div class="sa-siat-valore-pai"><i class="far fa-calendar-alt mr-1"></i> {{ pulisciData(pres.dataInizioInterventi) }}</div>
                                    </b-col>
                                    <b-col class="sa-siat-cols" cols="12" md="3">
                                        <div class="sa-siat-label-pai">Frequenza Pianificata</div>
                                        <div class="sa-siat-valore-pai">
                                            <i class="fas fa-history mr-1 text-info"></i>
                                            <template v-if="pres.frequenza"> {{ pres.frequenza.numeroInterventi }} int. / {{ pres.frequenza.numeroRipetizioni }} {{ pres.frequenza.utNumeroRipetizioni }} </template>
                                            <template v-else-if="pres.frequenzaVolte"> {{ pres.frequenzaVolte.numeroVolte }} volte in {{ pres.frequenzaVolte.numeroGiorni }} gg </template>
                                        </div>
                                    </b-col>
                                    <b-col class="sa-siat-cols" cols="12" md="3">
                                        <div class="sa-siat-label-pai">Figura Profezzionale</div>
                                        <div class="sa-siat-valore-pai" :class="'sa-siat-text-' + pres.figuraProfessionale.ra_cod">{{ pres.figuraProfessionale.value }}</div>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col class="sa-siat-cols" cols="12" md="6">
                                        <div class="sa-siat-label-pai">Descrizione Estesa</div>
                                        <div class="italic sa-siat-text-data">{{ pres.tipoPrestazione }} - {{ pac.pacchettoDescrizione }}</div>
                                    </b-col>
                                    <!-- <b-col v-if="pres.intervento.length > 0" class="sa-siat-cols text-right" cols="12" md="6">
                                        <button class="btn btn-success shadow-sm" @click.stop="onClickAccettaRifiutaPai(pres, ev, pac.pacchettoCodice, 'Accettato')"><i class="fas fa-check"></i> Accetta</button>
                                        <button class="btn btn-danger shadow-sm ml-2" @click.stop="onClickAccettaRifiutaPai(pres, ev, pac.pacchettoCodice, 'Respinto')"><i class="fas fa-times"></i> Rifiuta</button>
                                    </b-col> -->
                                    <b-col v-if="pac.statoRecord === 'NUOVO'" class="sa-siat-cols text-right" cols="12" md="6">
                                        <button v-if="pres.intervento.length > 0" class="btn btn-success shadow-sm" @click.stop="onClickAccettaRifiutaPai(pres, ev, pac.pacchettoCodice, 'Accettato')"><i class="fas fa-check"></i> Accetta</button>
                                        <button v-if="pres.intervento.length > 0" class="btn btn-danger shadow-sm ml-2" @click.stop="onClickAccettaRifiutaPai(pres, ev, pac.pacchettoCodice, 'Respinto')"><i class="fas fa-times"></i> Rifiuta</button>
                                    </b-col>
                                    <b-col v-else class="sa-siat-cols text-right" cols="12" md="6">
                                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-aperta'">{{ pac.statoRecord }} </span>
                                    </b-col>
                                </b-row>
                                <template v-if="pres.intervento.length > 0">
                                    <b-table sticky-header ref="table" stacked="xl" striped hover :items="pres.intervento" :fields="fields" :current-page="1" :per-page="1000" sort-icon-left head-variant="light" class="sa-b-table">
                                        <template #cell(stato)="row">
                                            <span class="badge badge-pill badge-light border sa-siat-badge"> {{ row.item.statoRecord }}</span>
                                        </template>
                                    </b-table>
                                </template>
                                <template v-else>
                                    <no-data-component ref="cmpNoDataComponent" title="Nessun Intervento da pianificare" :fontSize="15" :paddingSize="0.5" nome="no-data" />
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import SiatMixin from "../mixins/SiatMixin";
import praticaa from "./praticaa";
export default {
    components: { NoDataComponent },
    mixins: [SiatMixin],
    data() {
        return {
            fields: [
                {
                    label: "Numero Intervento",
                    key: "id",
                    sortable: false,
                },
                {
                    label: "Data Prevista",
                    key: "dataPrevista",
                    sortable: false,
                    formatter: (value) => {
                        if (!value) {
                            return "--";
                        } else {
                            return this.formatDate(value);
                        }
                    },
                },
                {
                    label: "Ora Prevista",
                    key: "oraPrevista",
                    sortable: false,
                },
                // {
                //     label: "Data Effettiva",
                //     key: "dataEffettiva",
                //     sortable: false,
                //     formatter: (value) => {
                //         if (!value) {
                //             return "--";
                //         } else {
                //             return this.formatDate(value);
                //         }
                //     },
                // },
                {
                    label: "Stato",
                    key: "statoRecord",
                    sortable: false,
                },
            ],
        };
    },
    computed: {
        praticheFiltrate() {
            praticaa;
            return this.pratiche.filter((p) => p.assistito.cognome.toLowerCase().includes(this.search.toLowerCase()) || p.assistito.codiceFiscale.toLowerCase().includes(this.search.toLowerCase()));
        },
    },
    methods: {
        bisogno(pratica) {
            return pratica?.bisogno?.toLowerCase();
        },
        loadData() {
            this.siatLoadLetturaPianiScelta();
        },
        togglePrestazione(pi_id) {
            const index = this.openPrestazioni.indexOf(pi_id);
            if (index > -1) {
                this.openPrestazioni.splice(index, 1);
            } else {
                this.openPrestazioni.push(pi_id);
            }
        },

        getFormatoEuro(value) {
            return value.toLocaleString("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        isPresOpen(pi_id) {
            return this.openPrestazioni.includes(pi_id);
        },
        pulisciData(d) {
            return d ? d.split("+")[0] : "-";
        },
        onConfermaLetturaScelta(item) {
            this.siatConfermaLetturaScelta(item);
        },
        effettuaPresa(item) {
            this.siatConfermaLettura(item);
        },
        getClassRecordEvento(ev) {
            let classe = "";
            if (ev.statoRecord == "LETTURA CONFERMATA") {
                classe = "sa-siat-data-complesso";
            } else {
                classe = "sa-siat-badge-aperta";
            }

            return "badge badge-pill badge-light border sa-siat-badge " + classe;
        },
    },
};
</script>

<style scoped>
/* Card Pratica */
.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 25px;
    overflow: hidden;
}

.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;
}

/* Sezione Prestazioni */
.sa-siat-prestazione-item {
    border: 1px solid #e2e8f0;
    margin: 8px 20px;
    border-radius: 8px;
    background: #fff;
    transition: all 0.2s ease;
}

.sa-siat-prestazione-header {
    padding: 12px 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.sa-siat-prestazione-header:hover {
    background: #f8fafc;
}

/* Colori per Figura */
.sa-siat-border-IP {
    border-left: 5px solid #3498db;
}

.sa-siat-border-FISIO {
    border-left: 5px solid #2ecc71;
}

.sa-siat-border-OSS {
    border-left: 5px solid #e67e22;
}

.sa-siat-border-PSIC {
    border-left: 5px solid #9b59b6;
}

.sa-siat-border-MED {
    border-left: 5px solid #e74c3c;
}

.sa-siat-text-IP {
    color: #3498db !important;
}

.sa-siat-text-FISIO {
    color: #2ecc71 !important;
}

.sa-siat-text-OSS {
    color: #e67e22 !important;
}

.sa-siat-text-PSIC {
    color: #9b59b6 !important;
}

.sa-siat-text-MED {
    color: #e74c3c !important;
}

.sa-siat-label-pai {
    font-weight: bold;
    color: #7f8c8d;
    text-transform: uppercase;
    font-size: 0.95rem;
}

.sa-siat-valore-pai {
    color: #2c3e50;
    font-weight: 600;
}

.sa-siat-row {
}

.sa-siat-cols {
    padding-right: 25px;
    padding-left: 25px;
}

.sa-siat-text-data {
    color: #c20000;
}

.sa-siat-text-indirizzo {
    font-size: 1rem;
}

.sa-siat-data {
    color: #e83e8c;
}

.sa-siat-badge {
    /* display: block; */
    font-size: 1rem;
    max-width: 200px;
}

.sa-siat-badge-aperta {
    color: #07af07;
}

.sa-siat-data-complesso {
    color: #e67e22;
}
</style>
